import { atom } from 'jotai'

export const DataAtom = atom(null)
export const UserAtom = atom(null)
export const reportKeywordsAtom = atom(null);